/**
 * @namespace Videoplayer
 * @aka Planet.Videoplayer
 *
 */
Planet.Videoplayer = (function ($, ardplayer) {

  var currentUrl = COMMON.Utils.parseUrl(window.location.href);
  if (currentUrl.params.hasOwnProperty('mediaId')) {
    var element = document.getElementById('player-' + currentUrl.params.mediaId);
    if (element) {
      element.scrollIntoView({
        behavior: 'auto',
        block: 'start',
        inline: 'start'
      });
    }
  }

  /**
   *
   * @type Array
   */
  var _observedElements = [];

  /**
   *
   * @param entries
   * @private
   */
  var _onIntersection = function _onIntersection(entries) {
    entries.forEach(function (entry) {
      // entry.isIntersecting is null on some versions of MS Edge
      // entry.intersectionRatio can be 0 on some intersecting elements
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        _intersecting(entry.target);
      }
    })
  }

  /**
   *
   * @return {*[]}
   * @private
   */
  var _buildThresholdList = function _buildThresholdList() {
    var thresholds = [];
    var numSteps = 20

    for (var i = 1.0; i <= numSteps; i++) {
      var ratio = i / numSteps;
      thresholds.push(ratio);
    }

    thresholds.push(0);
    return thresholds;
  }

  var rootMargin = '1250px';
  try {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection) {
      switch (connection.effectiveType) {
        case 'slow-2g':
        case '2g':
        case '3g':
          rootMargin = '2500px';
          break;
        case '4g':
        default:
          rootMargin = '1250px';
          break;
      }
    }
  } catch (exception) {
    /* noop */
  }

  /**
   *
   * @type {{root: null, rootMargin: string, threshold: *[]}}
   * @private
   */
  var _intersectionObserverOptions = {
    root: null,
    rootMargin: rootMargin,
    threshold: _buildThresholdList()
  };

  /**
   *
   * @type {IntersectionObserver}
   * @private
   */
  var _intersectionObserver = new window.IntersectionObserver(_onIntersection, _intersectionObserverOptions);

  var _intersectionUnobserve = function () {
    _observedElements.forEach(function (element) {
      _intersectionObserver.unobserve(element);
    })
    _observedElements = [];
  }

  /**
   *
   * @param element
   * @private
   */
  var _intersectionUnobserveElement = function (element) {
    try {
      _intersectionObserver.unobserve(element);
    } catch (exception) {
      /* noop */
    }

    try {
      var i = _observedElements.indexOf(element);
      if (i > -1) {
        _observedElements.splice(i, 1);
      }
    } catch (exception) {
      /* noop */
    }
  }

  /**
   *
   * @private
   */
  var _intersectionObserve = function (_elements) {
    _elements.forEach(function (_element) {
      if (!'IntersectionObserver' in window) {
        _intersecting(_element);
        return
      }
      _intersectionObserver.observe(_element);
      _observedElements.push(_element);
    })
  }

  /**
   *
   * @param {Element} element
   * @private
   */
  var _intersecting = function _intersecting(element) {
    var $element = $(element);
    Videoplayer._jQueryInterface.call($element, $element.data());
  }

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'videoplayer';
  var DATA_KEY = 'planet.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-spy="mediaplayer"]'
  };

  var Default = {
    baseurl: COMMON.Utils.assetBaseURL + '/assets/ardplayer/7.9.0/',
    isLive: false,
    autostart: false,
    geoblocked: false,
    dvr: false,
    duration: '',
    size: '',
    mute: false,
    embeddable: false,
    mediaTheme1: null,
    mediaTheme2: null,
    playerConfiguration: {}
  };

  var DefaultType = {
    baseurl: 'string',
    isLive: 'boolean',
    autostart: 'boolean',
    geoblocked: 'boolean',
    dvr: 'boolean',
    duration: '(string|number)',
    size: '(string|number)',
    mute: 'boolean',
    embeddable: 'boolean',
    mediaTheme1: '(null|string)',
    mediaTheme2: '(null|string)',
    playerConfiguration: '(null|object)'
  };

  function humanDuration(secs) {
    var sec_num = parseInt(secs, 10);
    var days = Math.floor(sec_num / 86400);
    var hours = Math.floor(sec_num / 3600) % 24;
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    seconds = seconds < 10 ? '0' + seconds : seconds;
    if (days > 0)
      minutes += days * 24 * 60;
    if (hours > 0)
      minutes += hours * 60;
    return minutes + ':' + seconds;
  }

  /**
   * Cleanup
   */
  // $(document).on('pjax:start', function (event, xhr, options) {
  //   $container = $(options.container);
  //   $container.find('.ardplayer').each(function () {
  //     var $element = $(this);
  //     $element.find('video, audio').each(function () {
  //       $(this).attr('autoplay', false)
  //     });
  //     var $mediaElement = $element.clone().attr({
  //       'class': null,
  //       'data-update-social-done': null
  //     });
  //     $mediaElement.find('.ardplayer-viewport').remove();
  //     $mediaElement.insertAfter($element);
  //     var playerId = $element.attr('data-uuid');
  //     ardplayer.removeArdPlayer(playerId);
  //     $(window).off('resize.' + playerId);
  //   })
  // });

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Videoplayer = function () {

    function Videoplayer(element, config) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(element);

      if (self.$element.hasClass('ardplayer'))
        return;

      self.lastState = null;

      self.config = self._getConfig(config);

      self.$mediaElement = self.$element.find('video:first, audio:first');
      if (0 === self.$mediaElement.length)
        return;

      if (self.config.config) {
        /*
         * Fix Path
         */
        var locationObject = COMMON.Utils.parseUrl(window.location.href);
        var configObject = COMMON.Utils.parseUrl(self.config.config);
        if (-1 !== window.location.hostname.indexOf('.swr.ard') && locationObject.host !== configObject.host) {
          try {
            var expression = /([a-z0-9\-]+)\.de$/i;
            var matches = configObject.host.match(expression);
            if (matches) {
              var portal = matches[1];

              var relativeConfigUrl = configObject.relative;
              var sliceAt = relativeConfigUrl.indexOf('/~') + 1;
              relativeConfigUrl = relativeConfigUrl.slice(sliceAt);

              var basePath = window.location.origin;

              self.config.config = basePath + '/' + portal + relativeConfigUrl;
            }
          } catch (exception) {
          }
        } else if (-1 !== window.location.hostname.indexOf('standby.')) {
          self.config.config = self.config.config.replace('www.', 'standby.');
        }
      }

      _intersectionUnobserveElement(self.element);

      self.$mediaElementClone = self.$element.children().clone(true, true);

      // Player ID für ATI
      self.playerId = Math.round(Math.random() * 10e15);

      self.type = self.$mediaElement.get(0).tagName.toLowerCase();

      self.loadConfiguration();
    }

    Videoplayer.prototype.loadConfiguration = function loadConfiguration() {
      var self = this;
      if (!self.config.config) {
        return;
      }

      /*
       * Fetch API
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
       */
      var apiRequestUrl = new URL(self.config.config, window.location.origin);
      fetch(apiRequestUrl.toString(), {
        headers: {
          'Accept': 'application/json, */*; q=0.01',
          'Content-Type': 'application/json'
        },
        method: 'GET',
        mode: 'cors',
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Request rejected with status ' + response.status + ' and message ' + response.statusText);
        }
        return response.json();
      }).then(function (data) {
        self.config.dvr = data.hasOwnProperty('live');

        var playerConfiguration = $.extend(true, {}, self._setupPlayerConfiguration(), self.config.playerConfiguration);
        var mediaCollection = self._prepareMediaCollection(data, playerConfiguration);
        console.debug('playerConfiguration', playerConfiguration);
        console.debug('MediaCollection', mediaCollection);

        self.loadContent(playerConfiguration, mediaCollection);
      }).catch(function (exception) {
        (console.error || console.log).call(console, exception.stack || exception)
      }).finally(function () {

      });
    }

    Videoplayer.prototype._prepareMediaCollection = function (mediaCollection, playerConfiguration) {
      var self = this;

      if ('audio' === self.type) {
        var images = [];
        if (playerConfiguration.hasOwnProperty('web') && playerConfiguration.web.hasOwnProperty('isForcedVideoView') && true === playerConfiguration.web.isForcedVideoView) {
          // Wir brauchen das 16x9 Bild
          images = mediaCollection.meta.images.filter(function (image) {
            return "preview" === image.kind
          })
        } else {
          // Wir brauchen das 1x1 Bild
          images = mediaCollection.meta.images.filter(function (image) {
            return "audio" === image.kind
          })
        }
        if (0 !== images.length) {
          mediaCollection.meta.images = images;
        }
      }

      var $parentEl = self.$element.parent();

      var shortLink = COMMON.Utils.getCanonical();
      var embedUrl = $parentEl.prevAll('link[itemprop~="embedUrl"]').prop('href') || '';

      var mediaId = (mediaCollection.hasOwnProperty('local@swr') && mediaCollection['local@swr'].hasOwnProperty('playerId') ? mediaCollection['local@swr'].playerId : self.$element.attr('data-media-id').replace('player-', ''));
      var title = mediaCollection.meta.title;
      var isLive = mediaCollection.hasOwnProperty('live');
      var isEmbeddable = (mediaCollection.hasOwnProperty('isEmbeddable') && mediaCollection.isEmbeddable) || (mediaCollection.hasOwnProperty('local@swr') && mediaCollection['local@swr'].hasOwnProperty('isEmbeddable') && mediaCollection['local@swr'].isEmbeddable);
      var isSharable = (mediaCollection.hasOwnProperty('isSharable') && mediaCollection.isSharable) || (mediaCollection.hasOwnProperty('local@swr') && mediaCollection['local@swr'].hasOwnProperty('isSharable') && mediaCollection['local@swr'].isSharable);

      var cookie = 'undefined' !== typeof Cookies.get('tracking_optout') ? Cookies.get('tracking_optout') : '';

      /*
       * Addon Piano
       */
      var $piano = $('#piano');
      if (
        cookie.indexOf('atInternet') === -1
        && 0 !== $piano.length
        && mediaCollection.pluginData.hasOwnProperty('trackingPiano@all')
      ) {
        var playerPosition = (self.$element.closest('.teaser').length !== 0 ? 'Teaser' : '');
        var launchReason = (self.config.autostart && self.$element.closest('.teaser-mediaplayer').length === 0 ? 'Autoplay' : 'Klick');
        var pageEmbedding = (window.parent !== window.top ? document.referrer : '')

        mediaCollection.pluginData['trackingPiano@all'] = $.extend(true, {}, mediaCollection.pluginData['trackingPiano@all'], {
          avContent: {
            av_launch_reason: launchReason,
            av_player_position: playerPosition,
            av_page_embedding: pageEmbedding
          },
          config: {
            events: [
              'av.jumpmark',
              'av.drop.player',
              'av.share',
              'av.quality',
              'av.dialog.open',
              'av.dialog.close',
              'av.playermode',
              'av.subtitle',
              'av.language',
              'av.audiodescription',
              'av.signlanguage',
              'av.volume',
              'av.volume.mute',
              'av.set.sleeptimer',
              'av.embed.click',
              'av.recommendation',
              'av.playlist'
            ]
          }
        });
      } else {
        delete mediaCollection.pluginData['trackingPiano@all'];
      }

      if (
        -1 === cookie.indexOf('agfNielsen') &&
        mediaCollection.pluginData.hasOwnProperty('trackingAgf@all')
      ) {
        /*
         * Addon AGF
         */
        mediaCollection.pluginData['trackingAgf@all'].isEnabled = true;
        mediaCollection.pluginData['trackingAgf@all'].debug = false;
      } else {
        delete mediaCollection.pluginData['trackingAgf@all'];
      }

      /*
       * Addon Sharing
       */
      mediaCollection.pluginData['sharing@web'] = {
        link: shortLink + '?mediaId=' + encodeURIComponent(mediaId) + (!self.config.isLive ? '&$params$' : ''),
        embedCode: isEmbeddable ? '<iframe src="' + embedUrl + '?$params$" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' : '',
        params: 'startTime=$start$&endTime=$ende$',
        legal: 'Durch die Einbettung von planet schule-Videos auf deiner Webseite stimmst du den <a href="https://www.swr.de/home/nutzungsbedingungen-player-100.html" target="_blank">Nutzungsbedingungen</a> zu.',
        body: 'Schau dir „' + title + '“ auf planet-schule.de an! %0D%0A %0D%0AWenn dir dieses ' + ('audio' === self.type ? 'Audio' : 'Video') + ' gefällt, siehe zu, dass du es auch teilst! %0D%0A %0D%0A$link$',
        subject: 'Schau dir „' + title + '“ auf planet-schule.de an',
        enableSharing: isSharable,
        services: [
          'twitter',
          'facebook',
          'fb-messenger',
          'whatsapp',
          'email',
          'embed',
          'url'
        ],
        disableSubclipping: isLive
      };

      if (!isEmbeddable || '' === embedUrl) {
        var index = mediaCollection.pluginData['sharing@web'].services.indexOf('embed');
        if (-1 !== index) {
          mediaCollection.pluginData['sharing@web'].services.splice(index, 1);
        }
      }

      return mediaCollection;
    }

    Videoplayer.prototype.loadContent = function loadContent(playerConfiguration, mediaCollection) {
      var self = this;

      var id = self.$element.attr('id');

      self.player = new ardplayer.Player(id, playerConfiguration, mediaCollection);
      $(self.player).data('playerId', self.playerId);

      /**
       *
       * @param {Event} event
       * @private
       */
      var _handleEventError = function (event) {
        //console.debug(event);
      };
      if ('function' === typeof self.player.addEventListener) {
        self.player.addEventListener(ardplayer.Player.EVENT_ERROR, _handleEventError);
      } else {
        self.player.$.on(ardplayer.Player.EVENT_ERROR, _handleEventError);
      }

      /**
       *
       * @param {Event} event
       * @private
       */
      var _handleEventReady = function (event) {
        var player = event.target;

        if (!player)
          return;

        $(document).trigger('planet:videoplayer:ready');

        // if (self.config.mute) {
        //   player.getCtrl().setMuted(true);
        // } else {
        //   player.getCtrl().setMuted(false);
        // }

        $(player).find('.ardplayer-viewport').not(':last').remove();
      };
      if ('function' === typeof self.player.addEventListener) {
        self.player.addEventListener(ardplayer.Player.EVENT_READY, _handleEventReady);
      } else {
        self.player.$.on(ardplayer.Player.EVENT_READY, _handleEventReady);
      }

      /**
       *
       * @param {Event} event
       * @private
       */
      var _handleEventPlayStream = function (event) {
        $(document).trigger('planet:videoplayer:play');

        if (self.config.isLive) {
          self.lastState = 'live';
        } else {
          self.lastState = null;
        }
      };
      if ('function' === typeof self.player.addEventListener) {
        self.player.addEventListener(ardplayer.Player.EVENT_PLAY_STREAM, _handleEventPlayStream);
      } else {
        self.player.$.on(ardplayer.Player.EVENT_PLAY_STREAM, _handleEventPlayStream);
      }

      $(document).on('pjax:beforeReplace', function (events, contents, options) {
        if (self.player) {

          /*
           * nur wenn dieser player im container liegt
           */
          if (0 === self.$element.closest(options.container).length) {
            return;
          }

          try {
            var playerUuid = self.$element.attr('data-uuid');
            var player = ardplayer.PlayerModel.getPlayerById(playerUuid);

            if (player) {
              player.stop();
              player.dispose();

              ardplayer.PlayerModel.forceRemovePlayer(player);
            }

            if (ardplayer.PlayerModel.autoPlayerAlreadyActive === playerUuid)
              ardplayer.PlayerModel.autoPlayerAlreadyActive = false;
          } catch (exception) {
          }

          $(window).off('resize' + EVENT_KEY);
          self.$element
            .find('.ardplayer-viewport').remove()
            .removeClass(function (index, className) {
              return (className.match(/(^|\s)ardplayer-\S+/g) || []).join(' ');
            })
            .removeClass('ardplayer')
            .off(EVENT_KEY);
          $.removeData(self.element, DATA_KEY);

          //self.$element.find('[class^="ardplayer-"],[class*=" ardplayer-"]').remove();
          self.$element.empty().append(self.$mediaElementClone);

          self.element = null;
          self.config = null;
          self.type = null;
          self.$mediaElement = null;
          self.$mediaElementClone = null;
          self.player = null;
        }

      });

      /**
       * Listen for common:audioplayer
       */
      $(document).on('common:audioplayer:is-playing', function (event, state) {
        var playerId = self.$element.attr('data-uuid');
        var player = ardplayer.PlayerModel.getPlayerById(playerId);

        if (state.isPlaying) {
          player.pause();
          //player.stop();
        } else {
          // Resume Livestream
          if ('live' === self.lastState && !player.getCtrl().isPlaying()) {
            if (player.getCtrl().mc.getDVREnabled()) {
              player.play();
            } else {
              player.play(0);
            }
            self.lastState = null;
          }
        }
      });

      $(document).on('common:audioplayer:playshy', function () {
        if (self.player) {
          var playerId = self.$element.attr('data-uuid');
          var player = ardplayer.PlayerModel.getPlayerById(playerId);
          // Stop livestream if it's not muted
          try {
            if (false === player.globalModel._muted) {
              player.pause();
            }
          } catch (e) {
          }
        }
      });
    }

    // public
    Videoplayer.prototype.dispose = function dispose() {
      _intersectionUnobserveElement(this.element);

      $(window).off('resize.' + this.playerId);
      $(this.element).off(EVENT_KEY);
      $.removeData(this.element, DATA_KEY);

      if (this.player) {
        this.player.stop();
        this.player.dispose();
      }

      //$(this.element).find('[class^="ardplayer-"],[class*=" ardplayer-"]').remove();
      $(this.element).empty().append(this.$mediaElementClone);

      this.element = null;
      this.$element = null;
      this.config = null;
      this.type = null;
      this.$mediaElement = null;
      this.$mediaElementClone = null;
      this.playerId = null;
      this.player = null;
    };

    // private
    Videoplayer.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    Videoplayer.prototype._setupPlayerConfiguration = function _setupPlayerConfiguration() {
      var self = this;

      var playerConfig = {
        generic: {
          isAutoplay: self.config.autostart,
          isDvrEnabled: (false !== self.config.dvr),
          isMuted: self.config.mute,
          isEmbedded: -1 !== window.location.href.indexOf('~embed'),
          imageTemplateConfig: {
            width: {
              min: 320,
              max: 1440,
              stepSize: 80
            },
            sizes: [{
              minWidth: 0,
              value: 'xs'
            }, {
              minWidth: 413,
              value: 'sm'
            }, {
              minWidth: 474,
              value: 'md'
            }, {
              minWidth: 850,
              value: 'lg'
            }, {
              minWidth: 1440,
              value: 'xl'
            }]
          }
        },
        web: {
          baseUrl: self.config.baseurl,
          isAudioSticky: false,
          isForcedAutoplay: self.config.autostart,
          enableBackButton: false,
          showBackButtonAsClose: false,
          disablePosterTitle: false
        },
        pluginData: {
          'airplay@all': {
            isDisabled: false
          }
        }
      };

      if ('audio' === self.type) {
        if (0 !== self.$element.closest('[data-spy=playlist]').length) {
          playerConfig.web.isForcedVideoView = true
        }
        playerConfig.web.isAudioSticky = false
      }

      if (!self.config.isLive) {
        var currentUrl = COMMON.Utils.parseUrl(window.location.href);
        if (currentUrl.params.hasOwnProperty('mediaId')) {
          var currentMediaId = self.$element.attr('id').replace('player-', '');
          if (currentMediaId === decodeURIComponent(currentUrl.params.mediaId)) {
            if (currentUrl.params.hasOwnProperty('startTime')) {
              playerConfig.generic.vodStartSeconds = Number(currentUrl.params.startTime) || null;
              if (-1 === window.location.href.indexOf('~embed')) {
                playerConfig.generic.isAutoplay = true;
                playerConfig.web.isForcedAutoplay = true;
              }
            }
            if (currentUrl.params.hasOwnProperty('endTime')) {
              playerConfig.generic.vodEndSeconds = Number(currentUrl.params.endTime) || null;
            }
          }
        } else {
          // Fallback für URLs ohne mediaId
          if (currentUrl.params.hasOwnProperty('startTime')) {
            playerConfig.generic.vodStartSeconds = Number(currentUrl.params.startTime) || null;
          }
          if (currentUrl.params.hasOwnProperty('endTime')) {
            playerConfig.generic.vodEndSeconds = Number(currentUrl.params.endTime) || null;
          }
        }
      }

      return playerConfig
    }

    // static
    Videoplayer._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : COMMON.Utils._typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Videoplayer(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    return Videoplayer;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  var elements = document.querySelectorAll(Selector.DATA_SPY);
  _intersectionUnobserve();
  _intersectionObserve(elements);
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    var container = document.querySelector(options.container);
    if (null === container) {
      return;
    }
    var elements = container.querySelectorAll(Selector.DATA_SPY);
    _intersectionUnobserve();
    _intersectionObserve(elements);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Videoplayer._jQueryInterface;
  $.fn[NAME].Constructor = Videoplayer;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Videoplayer._jQueryInterface;
  };

  return Videoplayer;

})(window.jQuery, window.ardplayer);

/*
 * Key-Moments schema.org
 */
(function ($) {

  var Event = {
    PJAX_DATA_API: 'pjax:end'
  };
  var Selector = {
    DATA_SPY: 'nav.mediaplayer-chapters'
  };

  var newLineRegex = /\r?\n|\r/g;
  var timeRegex = /(\s+\((\d{2}:)?\d{2}:\d{2}\s+min\))/i;

  var fixElements = function () {
    var shortLink = COMMON.Utils.getCanonical();

    return this.each(function () {
      var $element = $(this);

      var $figureElement = $element.parent('figure.asset.asset-video');
      var $buttonElements = $element.find('[data-toggle=mediaplayer-chapter]');

      var mediaId = $buttonElements.first().data('target').replace('#player-', '');
      var playerSelector = $buttonElements.first().data('target');

      var clips = [];
      var i = 0;
      $buttonElements.each(function () {
        var $btn = $(this);

        var label = $btn.text().replace(newLineRegex, ' ').replace(timeRegex, '').trim();

        var startTimeTS = $btn.data('jumpto');

        var deepLinkURL = new URL(shortLink, window.location.origin);
        deepLinkURL.searchParams.set('mediaId', mediaId);
        deepLinkURL.searchParams.set('startTime', startTimeTS);
        clips[i] = {
          url: deepLinkURL.toString(),
          label: label,
          startTime: startTimeTS,
          endTime: ''
        };
        if (0 !== i) {
          var j = i - 1;
          var endTimeTs = (startTimeTS - 1);
          clips[j].endTime = endTimeTs;
          var deepLinkURLwithEndTime = new URL(clips[j].url);
          deepLinkURLwithEndTime.searchParams.set('endTime', endTimeTs);
          clips[j].url = deepLinkURLwithEndTime.toString();
        }
        i++;
      });
      clips[(i - 1)].endTime = $(playerSelector).data('duration');

      clips.forEach(function (clip) {
        var partItem = COMMON.Utils.template('<span itemprop="hasPart" itemscope itemtype="https://schema.org/Clip">' +
          '<meta itemprop="name" content="{label}" >' +
          '<meta itemprop="url" content="{url}" >' +
          '<meta itemprop="startOffset" content="{startTime}" >' +
          '<meta itemprop="endOffset" content="{endTime}" >' +
          '</span>', clip);

        $figureElement.find('.video-player').before(partItem);
      });
    });
  }

  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    fixElements.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      fixElements.call($element);
    });
  });

})(window.jQuery);
